export default __webpack_public_path__ + "static/media/polygon-nav.8e9bddb5.png";